import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import UIKitPage from "./pages/UIKitPage";

import AboutPage from "./components/info/AboutPage";
import ShippingPage from "./components/info/ShippingPage";
import PrivacyPage from "./components/info/PrivacyPage";
import NewsPage from "./components/info/NewsPage";
import ContactsPage from "./components/info/ContactsPage";
import PaymentResult from "./pages/PaymentResult";
import OrderHistoryPage from "./auth/OrderHistoryPage";
import OrderDetailsPage from "./auth/OrderDetailsPage";

export default function Root() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/chat/:chatId" element={<App />} />

        <Route path="/ui-kit" element={<UIKitPage />} />

        <Route path="/payment-result" element={<PaymentResult />} />

        <Route path="/orders" element={<OrderHistoryPage />} />
        <Route path="/orders/:orderId" element={<OrderDetailsPage />} />

        <Route path="/about" element={<AboutPage />} />
        <Route path="/shipping" element={<ShippingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
      </Routes>
    </BrowserRouter>
  );
}